import React from "react";
import Slider from "react-slick";

const testimonials = [
  {
    id: 1,
    name: "Mr. Rohan Sharma",
    role: "Corporate Executive, Mumbai",
    image: "images/author-1.jpg",
    rating: 5,
    content:
      "Aaryan Travels has made my business trips completely hassle-free. Their punctual airport transfers and professional chauffeurs ensure I’m always on time for my meetings.",
  },
  {
    id: 2,
    name: "Miss. Priya Mehta",
    role: "HR Manager, Delhi",
    image: "images/author-2.jpg",
    rating: 5,
    content:
      "We regularly book Aaryan Travels for our corporate employee travel. The cars are clean, drivers are courteous, and service is extremely reliable across cities.",
  },
  {
    id: 3,
    name: "Mr. Arjun Patel",
    role: "Frequent Flyer, Ahmedabad",
    image: "images/author-3.jpg",
    rating: 4,
    content:
      "Their airport pickup and drop service is excellent — always on schedule and very convenient. I appreciate the professionalism and smooth communication.",
  },
  {
    id: 4,
    name: "Miss. Neha Kapoor",
    role: "Travel Coordinator, Pune",
    image: "images/author-4.jpg",
    rating: 5,
    content:
      "Aaryan Travels has been our go-to partner for corporate client transportation and intercity travel. They truly deliver comfort, safety, and reliability every single time.",
  },
];

const Testimonialsabout = () => {
  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992, // below desktop
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768, // below tablet/mobile
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const renderStars = (count) => {
    let stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <i
          key={i}
          className={`fa-star ${i <= count ? "fa-solid" : "fa-regular"}`}
        ></i>
      );
    }
    return stars;
  };

  return (
    <div className="our-testimonial">
      <div className="container">
        <div className="section-title">
          <h3>testimonials</h3>
          <h2>What our clients say about Aaryan Travels</h2>
        </div>
        <Slider {...settings}>
          {testimonials.map((t) => (
            <div key={t.id} className="testimonial-item">
              <div className="testimonial-header">
                <div className="testimonial-rating">{renderStars(t.rating)}</div>
                <div className="testimonial-content">
                  <p>{t.content}</p>
                </div>
              </div>
              <div className="testimonial-body">
                
                <div className="author-content">
                  <h3>{t.name}</h3>
                  <p>{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Testimonialsabout;
